import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import R from 'common/res/R';

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: R.spacing.xs,
    paddingVertical: R.spacing.xxs,
    backgroundColor: R.color.uiLightStain,
  },
  title: {
    color: R.color.textSecondary,
  },
});

function AutoCompleteSectionHeader({ title }) {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
    </View>
  );
}

AutoCompleteSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default AutoCompleteSectionHeader;
